module.exports = __webpack_public_path__ + "static/img/custom.b2fa43f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/custom.png
// module id = ucOl
// module chunks = 1